/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Optional task-specific capacity override. If omitted, inherit from EventKind.
 */
export type EventTaskConfigCapacityOverride = number | null;
